import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { AgentAbsence, EditAbsenceData } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function editAgentAbsence(absence: AgentAbsence, data: EditAbsenceData) {
  const { data: response } = await api.put(`/support/absences/${absence.id}`, data).then(axiosSuccess).catch(axiosError);
  return response;
}

export function useEditAgentAbsence() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ absence, data }: { absence: AgentAbsence; data: EditAbsenceData }) => editAgentAbsence(absence, data),
    {
      onSuccess: () => {
        handleRequestSuccess('Ausência atualizada com sucesso!');
        queryClient.invalidateQueries('agent-absences');
        queryClient.invalidateQueries('support-agents');
        queryClient.invalidateQueries('support-stats');
      },
      onError: (error: AxiosError) => {
        handleRequestError(error, 'Erro ao atualizar ausência. Tente novamente.');
      },
    }
  );
}
